export const CONTEXT_QUESTIONS = [
  'OCCURRENCE_DATE',
  'COUNTRIES',
  'CASES_YEAR_SAME_POLICY_EXT_PLUMBING_EM',
  'CASES_YEAR_SAME_POLICY_INT_PLUMBING_EM',
  'CASE_SOURCE',
  'CONTRACT_COUNTRY',
  'SERVICES',
  'CASES_YEAR_SAME_POLICY',
  'CASES_YEAR_SAME_POLICY_ELECTRICAL_EM',
  'CASES_YEAR_SAME_POLICY_ELECTRICAL_EM',
  'CASES_YEAR_SAME_POLICY_EXT_PLUMBING_EM',
  'CASES_YEAR_SAME_POLICY_EXT_PLUMBING_EM',
  'CASES_YEAR_SAME_POLICY_EXT_PLUMBING_EM',
  'CASES_YEAR_SAME_POLICY_GAS_EM',
  'CASES_YEAR_SAME_POLICY_GAS_EM',
  'CASES_YEAR_SAME_POLICY_HEATING_EM',
  'CASES_YEAR_SAME_POLICY_HEATING_EM',
  'CASES_YEAR_SAME_POLICY_INT_PLUMBING_EM',
  'CASES_YEAR_SAME_POLICY_INT_PLUMBING_EM',
  'CASES_YEAR_SAME_POLICY_INT_PLUMBING_EM',
  'CASES_YEAR_SAME_POLICY_RECONDITIONING',
  'CASES_YEAR_SAME_POLICY_RECONDITIONING',
  'CLAIMS_COST_12RM_SAME_INSURED_ASSET',
  'CLAIMS_COST_12RM_SAME_INSURED_ASSET',
  'CLAIMS_COST_12RM_SAME_POLICY',
  'CLAIMS_COST_12RM_SAME_POLICY',
  'CLAIMS_COST_12RM_SAME_POLICY_ELECTRICAL_EM',
  'CLAIMS_COST_12RM_SAME_POLICY_ELECTRICAL_EM',
  'CLAIMS_COST_12RM_SAME_POLICY_EXT_PLUMBING_EM',
  'CLAIMS_COST_12RM_SAME_POLICY_EXT_PLUMBING_EM',
  'CLAIMS_COST_12RM_SAME_POLICY_GAS_EM',
  'CLAIMS_COST_12RM_SAME_POLICY_GAS_EM',
  'CLAIMS_COST_12RM_SAME_POLICY_INT_PLUMBING_EM',
  'CLAIMS_COST_12RM_SAME_POLICY_INT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_ELECTRICAL_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_ELECTRICAL_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_EXT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_EXT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_GAS_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_GAS_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_INT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_INSURED_ASSET_INT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY',
  'CLAIMS_COST_YEAR_SAME_POLICY',
  'CLAIMS_COST_YEAR_SAME_POLICY_ELECTRICAL_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_ELECTRICAL_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_EXT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_EXT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_GAS_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_GAS_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_INT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_INT_PLUMBING_EM',
  'CLAIMS_COST_YEAR_SAME_POLICY_SER_LOCKS_ASSESS',
  'CLAIMS_COST_YEAR_SAME_POLICY_SER_LOCKS_ASSESS',
  'CLAIMS_COST_YEAR_SAME_POLICY_WATER_LOSS_INSURANCE',
  'CLAIMS_COST_YEAR_SAME_POLICY_WATER_LOSS_INSURANCE',
];
